import {
    ON_CLICK_APPLY, ON_CLICK_CLEAR, SAVE_FILTER, getText,
} from '@domain/campaigns/campaigns-filter';
import { createMiddleware } from '@shared/redux';
import { getObjectSelected } from '@domain/object-selected';
import { analytics } from '../../analytics';

const createTrackOfCampaignFilter = eventName => (state) => {
    const objectSelected = getObjectSelected(state);

    const { type } = objectSelected;

    analytics.track(eventName, { type });
};

export const campaignsFilterMiddleware = createMiddleware({
    [ON_CLICK_APPLY]: (state, action) => {
        const objectSelected = getObjectSelected(state);
        const { type } = objectSelected;

        const { field, operator, value } = action.payload;

        const rule = getText({
            value: value.value,
            field: field.value,
            operator: operator.value,
        });

        analytics.track('campaign_filter_apply_rule', { type, rule });
    },
    [SAVE_FILTER]: createTrackOfCampaignFilter('campaign_filter_save_filter'),
    [ON_CLICK_CLEAR]: createTrackOfCampaignFilter('campaign_filter_clear_filter'),
});
